<template>
  <i
    v-html="iconSvg"
    :style="{ color: color || 'currentColor' }"
    class="simple-icon v-icon"
    :class="`simple-icon--size-${size}`"
  ></i>
</template>

<script>
import { siTelegram } from 'simple-icons';

export default {
  name: 'SimpleIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: null
    }
  },
  computed: {
    iconSvg() {
      try {
        // Мапим иконки статически
        const iconMap = {
          'telegram': siTelegram
        };
        
        const icon = iconMap[this.name];
        
        if (!icon) {
          console.warn(`Icon "${this.name}" not found in Simple Icons`);
          return `<svg width="${this.size}" height="${this.size}" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="currentColor"/></svg>`;
        }
        
        // Создаем SVG с кастомными размерами и цветом
        let svg = icon.svg;
        
        // Убираем явные размеры, используем em из CSS
        svg = svg.replace(/width="24"/, '');
        svg = svg.replace(/height="24"/, '');
        
        // Если задан цвет, заменяем fill во всех элементах
        if (this.color) {
          // Заменяем существующие fill атрибуты
          svg = svg.replace(/fill="[^"]*"/g, `fill="${this.color}"`);
          // Добавляем fill к path элементам без fill
          svg = svg.replace(/<path(?![^>]*fill)/g, `<path fill="${this.color}"`);
          // Добавляем fill к svg элементу как fallback
          svg = svg.replace(/<svg/, `<svg fill="${this.color}"`);
        }
        
        return svg;
      } catch (error) {
        console.warn(`Error loading icon "${this.name}":`, error);
        return `<svg width="${this.size}" height="${this.size}" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="currentColor"/></svg>`;
      }
    }
  }
}
</script>

<style scoped>
.simple-icon {
  /* Имитируем стили v-icon от Vuetify */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-feature-settings: "liga";
  font-size: 1.5rem;
  height: 1em;
  width: 1em;
  min-width: 1em;
  line-height: 1;
  user-select: none;
  vertical-align: middle;
}

.simple-icon--size-24 {
  font-size: 1.5rem; /* 24px */
}

.simple-icon--size-20 {
  font-size: 1.25rem; /* 20px */
}

.simple-icon :deep(svg) {
  width: 1em;
  height: 1em;
  display: block;
  fill: currentColor;
}
</style>